export const StandardActions = {
  GET_STANDARD_DATA: "GET_STANDARD_DATA",
  SET_STANDARD_DATA: "SET_STANDARD_DATA",
  // define other action types here
};
